import React from 'react';
import { Email } from '@material-ui/icons';
import withUnreadConversationsCount from '../../../HOC/withUnreadConversationsCount';
import {Link} from "react-router-dom";

@withUnreadConversationsCount
class HeaderInboxLink extends React.Component {
  render () {
    const { numOfUnreadConversations: num } = this.props;
    let className = 'mobile-header-nav-private-chat';
    if (num > 0) {
      className += ' mobile-header-nav-private-chat--with-unread-conversations';
    }
    return (
      <Link title="Private Chat" to="/chat">
        <div className={className}>
          <Email fontSize="large" />
          {num > 0 && (
            <span
              title={`${num} unread conversation${num > 1 ? 's' : ''}`}
              className="mobile-header-nav-private-chat__unread-count">
              {num}
            </span>
          )}
        </div>
      </Link>
    );
  }
}

export default HeaderInboxLink;